export default {
  ru: 'Выберите язык',
  en: 'Select language',
  ua: "Оберіть мову"
}
